export default "__VITE_ASSET__142a7228__"